export const URL_BASE = '/api/v1/trustee/'
export const NAME_TOKEN = 'TOKEN_AUTH'